import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Text, TextButton } from "@zillow/constellation";
import { PostsLayout, PostCard } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { getGraphQLData } from "../../graphql/graphql.esm.js";
import { POSTS_BLOCK_QUERY } from "../../graphql/queries/post.esm.js";
const Posts = ({
  attrs,
  blockData = {}
}) => {
  const {
    heading,
    allLink,
    layout = "GRID",
    loading = "lazy",
    size = "lg",
    alignment = "horizontal"
  } = attrs;
  const {
    posts
  } = blockData;
  const items = posts.map((post) => {
    var _a, _b, _c;
    return {
      id: post == null ? void 0 : post.id,
      title: (_a = post == null ? void 0 : post.title) == null ? void 0 : _a.raw,
      excerpt: (_b = post == null ? void 0 : post.excerpt) == null ? void 0 : _b.raw,
      loading,
      image: post.featuredImage || void 0,
      category: post.primaryCategory || ((_c = post.categories) == null ? void 0 : _c[0]) || void 0,
      readTime: post.readTime,
      url: {
        href: post.link
      }
    };
  });
  return /* @__PURE__ */ jsxs(Box, { sx: {
    margin: "0 0 $spacing.md 0",
    height: layout === "SINGLE" ? "100%" : void 0
  }, children: [
    heading && (allLink == null ? void 0 : allLink.link) && /* @__PURE__ */ jsxs(Box, { sx: {
      margin: "0 0 $spacing.md 0",
      display: "flex"
    }, children: [
      heading && /* @__PURE__ */ jsx(Box, { sx: {
        flex: "1 1 0"
      }, children: /* @__PURE__ */ jsx(Text, { fontType: "h4", fontColor: "textDarkBlue", children: heading }) }),
      (allLink == null ? void 0 : allLink.link) && /* @__PURE__ */ jsx(Box, { sx: {
        paddingLeft: "$spacing.xs",
        display: "flex",
        justifySelf: "flex-end",
        justifyContent: "flex-end"
      }, children: /* @__PURE__ */ jsx(TextButton, { href: allLink.link, as: "a", iconPosition: "end", "aria-label": heading, children: allLink.text ? allLink.text : "See all" }) })
    ] }),
    layout !== "SINGLE" && /* @__PURE__ */ jsx(PostsLayout, { layout, items }),
    layout === "SINGLE" && /* @__PURE__ */ jsx(PostCard, { ...items[0], loading, alignment, size })
  ] });
};
Posts.getBlockData = async ({
  attrs
}) => {
  var _a;
  const {
    curatedPosts,
    type = "query",
    site = "LEARN",
    taxonomy,
    terms,
    perPage = "4",
    postType = "POST",
    order = "DESC",
    orderby = "DATE"
  } = attrs;
  const options = {
    postType: postType.toUpperCase(),
    site
  };
  if (type === "query") {
    if (taxonomy === "category") {
      options.taxonomies = [{
        taxonomy: "CATEGORY",
        ids: terms
      }];
    } else if (taxonomy === "post_tag") {
      options.taxonomies = [{
        taxonomy: "POST_TAG",
        ids: terms
      }];
    }
    options.perPage = perPage == null ? void 0 : perPage.toString();
    options.orderby = orderby.toUpperCase();
    options.order = order.toUpperCase();
  } else {
    options.include = (curatedPosts == null ? void 0 : curatedPosts.map((curatedPost) => curatedPost.toString())) || [];
    options.orderby = "INCLUDE";
  }
  try {
    const data = await getGraphQLData({
      query: POSTS_BLOCK_QUERY,
      variables: options,
      fetchPolicy: "no-cache"
    });
    return {
      posts: ((_a = data == null ? void 0 : data.cmsPosts) == null ? void 0 : _a.posts) || []
    };
  } catch (error) {
    console.error("Error fetching posts block data", error);
    return {
      posts: []
    };
  }
};
Posts.propTypes = {
  attrs: PropTypes.shape({
    heading: PropTypes.string,
    allLink: PropTypes.shape({
      link: PropTypes.string,
      text: PropTypes.string
    }),
    layout: PropTypes.oneOf(["GRID", "INLINE", "MOSAIC"])
  }),
  blockData: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.shape({
        raw: PropTypes.string
      }),
      excerpt: PropTypes.shape({
        raw: PropTypes.string
      }),
      categories: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        link: PropTypes.string
      })),
      primaryCategory: PropTypes.shape({
        name: PropTypes.string,
        link: PropTypes.string
      }),
      featuredImage: PropTypes.shape({
        mediaDetails: PropTypes.shape({
          sizes: PropTypes.shape({
            large: PropTypes.shape({
              sourceUrl: PropTypes.string,
              width: PropTypes.number,
              height: PropTypes.number
            }),
            medium: PropTypes.shape({
              sourceUrl: PropTypes.string,
              width: PropTypes.number,
              height: PropTypes.number
            })
          })
        })
      }),
      readTime: PropTypes.number
    }))
  })
};
export {
  Posts as default
};
